/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService
 */
import * as References from './SensitiveDataStatusControllerFrontendService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#enableSensitiveDataAsync
 */
export const ENABLE_SENSITIVE_DATA_ASYNC_MUTATION_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_enableSensitiveDataAsync';
export const ENABLE_SENSITIVE_DATA_ASYNC_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ENABLE_SENSITIVE_DATA_ASYNC_MUTATION_FIELD_NAME,
  args: ['sensitiveDataResponses'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.enableSensitiveDataAsyncRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#disableSensitiveDataAsync
 */
export const DISABLE_SENSITIVE_DATA_ASYNC_MUTATION_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_disableSensitiveDataAsync';
export const DISABLE_SENSITIVE_DATA_ASYNC_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DISABLE_SENSITIVE_DATA_ASYNC_MUTATION_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.disableSensitiveDataAsyncRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getSensitiveDataOnboardingOrEnabled
 */
export const GET_SENSITIVE_DATA_ONBOARDING_OR_ENABLED_QUERY_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getSensitiveDataOnboardingOrEnabled';
export const GET_SENSITIVE_DATA_ONBOARDING_OR_ENABLED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SENSITIVE_DATA_ONBOARDING_OR_ENABLED_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getSensitiveDataOnboardingOrEnabledRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getSensitiveDataSubsettings
 */
export const GET_SENSITIVE_DATA_SUBSETTINGS_QUERY_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getSensitiveDataSubsettings';
export const GET_SENSITIVE_DATA_SUBSETTINGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SENSITIVE_DATA_SUBSETTINGS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getSensitiveDataSubsettingsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#updateSubsettingsAsync
 */
export const UPDATE_SUBSETTINGS_ASYNC_MUTATION_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_updateSubsettingsAsync';
export const UPDATE_SUBSETTINGS_ASYNC_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_SUBSETTINGS_ASYNC_MUTATION_FIELD_NAME,
  args: ['subsettingsToUpdate'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.updateSubsettingsAsyncRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getSensitiveDataStateAndSubsettingsForPortal
 */
export const GET_SENSITIVE_DATA_STATE_AND_SUBSETTINGS_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getSensitiveDataStateAndSubsettingsForPortal';
export const GET_SENSITIVE_DATA_STATE_AND_SUBSETTINGS_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SENSITIVE_DATA_STATE_AND_SUBSETTINGS_FOR_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getSensitiveDataStateAndSubsettingsForPortalRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getSensitiveDataStateForPortal
 */
export const GET_SENSITIVE_DATA_STATE_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getSensitiveDataStateForPortal';
export const GET_SENSITIVE_DATA_STATE_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SENSITIVE_DATA_STATE_FOR_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getSensitiveDataStateForPortalRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getPortalDisablementPermitted
 */
export const GET_PORTAL_DISABLEMENT_PERMITTED_QUERY_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getPortalDisablementPermitted';
export const GET_PORTAL_DISABLEMENT_PERMITTED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_DISABLEMENT_PERMITTED_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getPortalDisablementPermittedRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getPortalEligibilityForSensitiveData
 */
export const GET_PORTAL_ELIGIBILITY_FOR_SENSITIVE_DATA_QUERY_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getPortalEligibilityForSensitiveData';
export const GET_PORTAL_ELIGIBILITY_FOR_SENSITIVE_DATA_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_ELIGIBILITY_FOR_SENSITIVE_DATA_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getPortalEligibilityForSensitiveDataRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getMaskingOptIn
 */
export const GET_MASKING_OPT_IN_QUERY_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getMaskingOptIn';
export const GET_MASKING_OPT_IN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MASKING_OPT_IN_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getMaskingOptInRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#setMaskingOptIn
 */
export const SET_MASKING_OPT_IN_MUTATION_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_setMaskingOptIn';
export const SET_MASKING_OPT_IN_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_MASKING_OPT_IN_MUTATION_FIELD_NAME,
  args: ['optedIn'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.setMaskingOptInRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getBreezeAccessOptIns
 */
export const GET_BREEZE_ACCESS_OPT_INS_QUERY_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getBreezeAccessOptIns';
export const GET_BREEZE_ACCESS_OPT_INS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BREEZE_ACCESS_OPT_INS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.getBreezeAccessOptInsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#setBreezeAccessOptIn
 */
export const SET_BREEZE_ACCESS_OPT_IN_MUTATION_FIELD_NAME = 'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_setBreezeAccessOptIn';
export const SET_BREEZE_ACCESS_OPT_IN_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_BREEZE_ACCESS_OPT_IN_MUTATION_FIELD_NAME,
  args: ['optedIn', 'optInType'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.setBreezeAccessOptInRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});